import type { CSSProperties } from 'react';
import styled from 'styled-components';

import {
  HALLOWEEN_GOLDEN_STYLE,
  HALLOWEEN_STYLE,
} from '@sorare/core/src/components/card/ScarcityBackground';

import defaultBackground from './assets/default.jpg';
import goldenBackground from './assets/golden.jpg';

const Root = styled.div`
  position: absolute;
  inset: 0;
  background: var(--bg-url) no-repeat center center;
  background-size: cover;
  z-index: 0;
`;

type Props = {
  golden?: boolean;
  halloween?: boolean;
};
export const Background = ({ golden, halloween }: Props) => {
  return (
    <Root
      style={
        {
          // eslint-disable-next-line no-nested-ternary
          background: halloween
            ? golden
              ? HALLOWEEN_GOLDEN_STYLE
              : HALLOWEEN_STYLE
            : `url(${golden ? goldenBackground : defaultBackground})  no-repeat center center`,
        } as CSSProperties
      }
    />
  );
};
